<div class="organization-info">
	<div class="col fav" (click)="onToggleFavorite(isFavorite)">
		<img
			alt=""
			src="../../../../../../assets/icons/sanus-fav-{{
				isFavorite ? 'on' : 'off'
			}}.svg"
		/>
	</div>
	<div class="col">
		<span class="information-label">Empresa</span>
		<span class="information-value to-ellipsis">
			{{ name }} {{ isMatriz ? '(matriz)' : '' }}
		</span>
	</div>
	<div class="col hide-on-mobile">
		<span class="information-label">Usuários</span>
		<span class="information-value">{{ totalUsers || 0 }}</span>
	</div>
	<div class="col">
		<span class="information-label">Beneficiários</span>
		<span class="information-value">{{ totalBeneficiaries || 0 }}</span>
	</div>
	<div class="col">
		<span class="information-label">CNPJ</span>
		<span class="information-value">{{ cnpj }}</span>
	</div>
	<div class="col">
		<span class="information-label">Estado</span>
		<span class="information-value">{{ state }}</span>
	</div>
	<div class="more-options-icon" [matMenuTriggerFor]="menu">
		<mat-icon svgIcon="sanus-more-blue"></mat-icon>
	</div>
	<mat-menu #menu="matMenu">
		<button mat-menu-item (click)="onEditGroup(name)">Editar cliente</button>
	</mat-menu>
</div>
